import React, { useState } from 'react';
import { MarketModal } from '../../../Shared';
import { EditMarketForm } from '../MarketForm';
import { ItemHeadMarket } from '../ItemHeadMarket';
import { ItemMarket } from '../ItemMarket';
import './TableMarket.css';

export function TableMarket(props) {
    const {markets, onReload ,selectMarket, selectNetwork, selectMembership} = props;



  return (
    <>



        <div className='table-market'>
            <table>
            <ItemHeadMarket />

            {markets
          .filter((value) => {
          if(selectMarket  && selectNetwork  && selectMembership) {
            console.log("ALL" + selectMarket + selectNetwork  +selectMembership )
            
            return (
             ( value.market === selectMarket || "Select" ===  selectMarket)&&
              (value.network === selectNetwork  || "Select" ===  selectNetwork) &&
              (value.membership === selectMembership || "Select" ===  selectMembership)
            );
        } else if  (selectMarket && selectNetwork) {  
            return (
                ( value.market === selectMarket || "Select" ===  selectMarket)&&
                 (value.network === selectNetwork  || "Select" ===  selectNetwork)
                
               );
          } else if  (selectMarket) {
        
             return (value.market === selectMarket  ||selectMarket ==="Select" );
            
            
          } else if (selectNetwork ) {
          
                return (value.network === selectNetwork || selectNetwork ==="Select" );
            
            
          } else if (selectMembership) {
            return (value.membership === selectMembership || selectMembership ==="Select" );
          } else {
            return true;
          }
        })
        .map((market) => (
          <ItemMarket key={market.id} market={market} onReload={onReload}/>
        ))
        }
           
    
            </table>
        </div>

        
    </>
  )
}
